export default "__VITE_ASSET__DFD6l75D__"